import { Injectable } from '@angular/core';
import { DZ_COLOR_GREEN_100, DZ_COLOR_GREEN_200, DZ_COLOR_GREEN_300, DZ_COLOR_GREEN_400, DZ_COLOR_GREEN_500, DZ_COLOR_PINK_200, DZ_COLOR_PINK_300, DZ_COLOR_PINK_400, DZ_COLOR_PINK_500, DZ_COLOR_PURPLE_100, DZ_COLOR_PURPLE_200, DZ_COLOR_PURPLE_300, DZ_COLOR_PURPLE_400, DZ_COLOR_PURPLE_500, DZ_COLOR_YELLOW_200, DZ_COLOR_YELLOW_300, DZ_COLOR_YELLOW_400, DZ_COLOR_YELLOW_500 } from '@blk/daisy/core/styles';

@Injectable()
export class ColorsConfig {
	public static readonly DEFAULT_CATEGORICAL_COLORS_ORDERING: string[] = ['#8F63BC', '#008B5C', '#FC9BB3', '#CC0018', '#FFCE00'];

	public static readonly DEFAULT_SEQUENTIAL_COLORS_ORDERING: string[] = ['#008B5C', '#8F63BC', '#FC9BB3', '#FFCE00', '#CC0018', '#9CD7BD', '#C7B2DE'];

	public static readonly SEQUENTIAL_NON_PORTFOLIO_ORDERING: string[] = [
		'#008B5C', '#FC9BB3', '#8F63BC', '#FFCE00', '#CC0018',
		'#9CD7BD', '#C7B2DE', '#FFC8CD', '#FFE67F', '#01573C',
		'#F2A800', '#A5A5A5'
	];

	public static readonly MULTI_SERIES_PORTFOLIO_COLORS = [
		['#008B5C', '#8F63BC', '#FC9BB3', '#FFCE00', '#CC0117', '#9CD7BD', '#C7B2DE'],
		['#9CD7BD', '#C7B2DE', '#FFC8CD'],
		['#BFF5DD', '#E6D2FB', '#FFDFE1']
	];

	public static readonly DEFAULT_COLOR_FOR_OTHER: string = '#A5A5A5';

	public static readonly PORTFOLIO_COLORS = ['#008B5C', '#8F63BC', '#FC9BB3', '#FFCE00', '#CC0018', '#9CD7BD', '#C7B2DE'];

	public static readonly MEGATRENDS_PORTFOLIO_COLORS = ['#008B5C', '#9BD7BE', '#8F63BC', '#CDB9E6', '#FC9BB3', '#FFC8CD'];

	public static readonly MONITORING_GLOBAL_COMPOSITE_BENCHMARK_COLORS = ['#008B5C', '#6E3FA3', '#B287DF'];

	public static readonly ASSET_CLASS_COLORS: any = {
		Empty: '#dddddd',
		'US Equities': '#6E3FA3',
		'Non-US/International Equities': '#8F63BC',
		'International/Global Equities': '#B287DF',
		'International Equities': '#B287DF',
		'Sector Equities': '#C7B2DE',
		'Sector Equity': '#C7B2DE',
		'US Fixed Income': '#008B5C',
		'Non-US/International Fixed Income': '#00AE73',
		'International/Global Fixed Income': '#9CD7BD',
		'Global Fixed Income': '#9CD7BD',
		'Multi Asset': '#FC9BB3',
		'Multi-Asset': '#FC9BB3',
		'Allocation': '#FC9BB3',
		'Equity': '#8F63BC',
		'Fixed Income': '#008B5C',
		Alternatives: '#CC0018',
		'Alternative': '#CC0018',
		Cash: '#FFCE00',
		'Australian Fixed Income': DZ_COLOR_GREEN_400,
		'International Fixed Income': DZ_COLOR_GREEN_200,
		'Emerging Equity': DZ_COLOR_PURPLE_300,
		'Emerging Markets Equities': DZ_COLOR_PURPLE_300,
		'Emerging Market Equities': DZ_COLOR_PURPLE_300,
		'Developed Equity': DZ_COLOR_PURPLE_200,
		'Developed Markets Equities': DZ_COLOR_PURPLE_200,
		'Developed Market Equities': DZ_COLOR_PURPLE_200,
		'Australian Equity': DZ_COLOR_PURPLE_500,
		'Australian Equities': DZ_COLOR_PURPLE_500,
		'Factor Equities': DZ_COLOR_PURPLE_100,
		'Property & Infrastructure': DZ_COLOR_PURPLE_100,
		'Cash & Cash Alternatives': '#FFCE00',
		Default: '#772654',
		Other: '#A5A5A5'
	};

	public static readonly ASSET_CLASS_FONT_COLORS: any = {
		Empty: '#000000',
		Other: '#000000'
	};

	public static readonly ASSET_ALLOCATION_COLORS: any = {
		usStock: '#8F63BC',
		nonUsStock: '#C7B2DE',
		usBond: '#008B5C',
		nonUsBond: '#9CD7BD',
		cash: '#FFCE00',
		other: '#a5a5a5'
	};

	public static readonly ASSET_CLASS_DECOMPOSITION_COLORS: any = {
		usEquities: '#8F63BC',
		nonUSInternationalEquities: '#C7B2DE',
		internationalGlobalEquities: '#C7B2DE',
		usFixedIncome: '#008B5C',
		nonUSInternationalFixedIncome: '#9CD7BD',
		internationalGlobalFixedIncome: '#9CD7BD',
		multiAsset: '#FC9BB3',
		alternatives: '#CC0018',
		cash: '#FFCE00',
		other: '#a5a5a5'
	};

	public static readonly REGION_COLORS: any = {
		'United States': '#8F63BC',
		'Developed Markets': '#008B5C',
		'Emerging Markets': '#FC9BB3',
		'Other': '#A5A5A5'
	};

	public static readonly FIXED_INCOME_CREDIT_RATINGS_COLORS: any = {
		'aaa': '#01573C',
		'aa': '#008B5C',
		'a': '#9CD7BD',
		'bbb': '#F2A800',
		'bb': '#FFCE00',
		'b': '#FFE67F',
		'belowB': '#C80257',
		'ccc': '#C80257',
		'cc': '#FC9BB3',
		'c': '#FFC8CD',
		'other': '#B5B5B5',
		'notRated': '#000000',
		'NR': '#000000'
	};

	public static readonly REGION_BREAKDOWN_COLORS: any = {
		'unitedStates': '#008B5C',
		'canada': '#FC9BB3',
		'unitedKingdom': '#8F63BC',
		'eurozone': '#FFCE00',
		'europeExEuro': '#CC0018',
		'japan': '#9CD7BD',
		'asiaDeveloped': '#C7B2DE',
		'australasia': '#FFC8CD',
		'latinAmerica': '#FFE67F',
		'europeEmerging': '#01573C',
		'middleEast': '#F2A800',
		'africa': '#6E3FA3',
		'asiaEmerging': '#A5A5A5',
		'other': '#000000'
	};

	public static readonly EQUITY_SECTOR_ALLOCATION_COLORS: any = {
		'Energy': '#8F63BC',
		'Basic Materials': '#008B5C',
		'Industrials': '#FC9BB3',
		'Consumer Cyclical': '#8F63BC',
		'Consumer Defensive': '#008B5C',
		'Healthcare': '#FC9BB3',
		'Financial Services': '#8F63BC',
		'Technology': '#008B5C',
		'Communication Services': '#FC9BB3',
		'Utilities': '#008B5C',
		'Real Estate': '#FC9BB3',
		Other: '#8F63BC',
		other: '#8F63BC',
		unknown: '#A5A5A5',
		Unknown: '#A5A5A5'
	};

	public static readonly TOTAL_RISK_COLORS: any = {
		'Alternative': '#F97070',
		'Dividend Yield': '#C7B2DE',
		'Earnings Yield': '#C7B2DE',
		'Equity Country Non US': '#8F63BC',
		'Equity Market': '#6E3FA3',
		Equity: '#8F63BC',
		'Equity Sector': '#B287DF',
		'Equity Style Size': '#C7B2DE',
		'Equity Style Other': '#C7B2DE',
		'Emerging': '#C7B2DE',
		'Foreign Exchange': '#FFCE00',
		Growth: '#C7B2DE',
		Idiosyncratic: '#FC9BB3',
		Inflation: '#9CD7BD',
		'Rates Inflation': '#9CD7BD',
		Leverage: '#C7B2DE',
		'Liquidity': '#C7B2DE',
		Momentum: '#C7B2DE',
		'Oil': '#C7B2DE',
		Other: '#A5A5A5',
		'Other Alternative': '#F97070',
		'Other Commodity': '#CC0018',
		Profitability: '#C7B2DE',
		Rates: '#008B5C',
		'Rates Non-USD': '#008B5C',
		'Rates USD': '#008B5C',
		'Reversal': '#C7B2DE',
		'Sentiment': '#C7B2DE',
		'Size': '#C7B2DE',
		'SmallCap': '#C7B2DE',
		'Spreads': '#00AE73',
		'Spreads EM': '#00AE73',
		'Spreads High Yield': '#00AE73',
		'Spreads Investment Grade': '#00AE73',
		'Spreads Loans - Credit': '#00AE73',
		'Spreads Municipal': '#00AE73',
		'Spreads Securitized': '#00AE73',
		'United States': '#8F63BC',
		Value: '#C7B2DE',
		Volatility: '#C7B2DE'
	};

	// this is temporary until we figure out what should we do with color dictionary
	public static readonly COLORS_DICTIONARY: any = {
		WHITE: '#fff',
		GRAY_E4: '#e4e4e4',
		BLK_NEUTRAL: '#efefef'
	};

	public static readonly SCENARIO_ANALYSIS_COLORS = [
		['#01573C', '#008B5C', '#00AE73', '#9CD7BD', '#A5A5A5'],
		['#6E3FA3', '#8F63BC', '#B287DF', '#C7B2DE', '#A5A5A5'],
		['#C80257', '#FC9BB3', '#FEB4BF', '#FFC8CD', '#A5A5A5']
	];

	public static readonly EQUITY_STYLE_COLORS = [
		[DZ_COLOR_GREEN_500, DZ_COLOR_GREEN_400, DZ_COLOR_GREEN_300, DZ_COLOR_GREEN_200],
		[DZ_COLOR_PURPLE_500, DZ_COLOR_PURPLE_400, DZ_COLOR_PURPLE_300, DZ_COLOR_PURPLE_200],
		[DZ_COLOR_PINK_500, DZ_COLOR_PINK_400, DZ_COLOR_PINK_300, DZ_COLOR_PINK_200],
		[DZ_COLOR_YELLOW_500, DZ_COLOR_YELLOW_400, DZ_COLOR_YELLOW_300, DZ_COLOR_YELLOW_200]
	];

	public static readonly PRODUCT_COLORS = {
		'ishares-fund-data': '#008B5C',
		'blk-mutual-fund-data': '#8F63BC',
		'multi-asset': '#FC9BB3',
		multiasset: '#FC9BB3',
		alternative: '#FC9BB3',
		ca: '#FC9BB3',
		comm: '#FC9BB3',
		eq: '#8F63BC',
		'equity-income': '#8F63BC',
		'fixed-income': '#008B5C',
		fi: '#008B5C',
		'one.ishares-fund-data': '#008B5C'
	};

	// Insight cards color is yellow, pink, purple, yellow. It's not following categorical or sequential order
	// because it's not data/graph, it's content, so it has different constraints to follow.
	public static readonly INSIGHT_TAB_COLORS = ['#FFCE00', '#FC9BB3', '#8F63BC'];

	public static readonly INSIGHT_TAB_COLORS_WITH_ADDITION = ['#FC9BB3', '#8F63BC', '#FFCE00'];

	public static readonly CTA_COLOR = '#FF4713';
	public static readonly BOX_CHART_COLORS = {
		DEFAULT: '#efefef',
		FILL: '#efefef',
		MEDIAN: '#FF4713',
		STEM: '#616161',
		WHISKER: '#616161'
	};

	public static readonly OVERVIEW_BACKGROUND_COLOR = '#ffe6c7';

	public static readonly INSIGHT_FUND_HOLDING_FIRST_VALUE_COLOR = {
		RED: 143,
		GREEN: 99,
		BLUE: 188
	};

	public static readonly INSIGHT_FUND_HOLDING_SECOND_VALUE_COLOR = {
		RED: 0,
		GREEN: 139,
		BLUE: 92
	};

	public static readonly CORRELATION_MATRIX_CATEGORY_COLOR = {
		NEGATIVE: '#9BD7BE',
		UNCORRELATED: '#BFF5DD',
		LOW: '#FFF3BF',
		MODERATE: '#FFE67F',
		HIGH: '#FFB194',
		VERY_HIGH: '#FF6E42'
	};

	public static readonly DZ_GREEN_SHADE_ORDERING = [DZ_COLOR_GREEN_100, DZ_COLOR_GREEN_200, DZ_COLOR_GREEN_300, DZ_COLOR_GREEN_400, DZ_COLOR_GREEN_500];

	public static readonly ESG_UPLIFT_COLORS = ['#008b5c', '#8e63bc', '#c80159', '#f2a900', '#990012', '#ff4613'];

	public static readonly ESG_UPLIFT_BENCHMARK_COLORS = ['#9bd7be', '#cdb9e6', '#ffc8cd', '#fddd00', '#f97070', '#ffb194'];

}
